import { render, staticRenderFns } from "./HelpPageView.vue?vue&type=template&id=346bd7ce"
import script from "./HelpPageView.vue?vue&type=script&lang=ts"
export * from "./HelpPageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports